import React from "react";
import { SnackbarProvider } from "notistack";

import flagsmith from "flagsmith";
import { FlagsmithProvider } from "flagsmith/react";

import { CssBaseline, ThemeProvider } from "@material-ui/core";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";

import { ThemeProvider as ThemeProviderV5 } from "@mui/material";

import DateFnsUtils from "@date-io/date-fns";
import ptBRLocale from "date-fns/locale/pt-BR";

import { ProgrammingTransportProvider } from "@context/ProgrammingTransport/ProgrammingTransportContext";
import { HomeUserContextProvider } from "@context/HomeUserContext";
import { IoCProvider } from "@context/IoCContext/IoCContext";
import { UserProvider } from "@context/UserContext";
import { AuthProvider } from "@context/auth/AuthContext";

import Themev5 from "@components/Theme/themev5";
import Routes from "@components/Routes";
import Theme from "@components/Theme";

import { isDevelopment } from "@config/appConfig";
import { datadogRum } from "@datadog/browser-rum";

const App: React.FC = () => {
  console.info("isDevelopment:", isDevelopment);

  return (
    <FlagsmithProvider
      options={{
        environmentID: isDevelopment
          ? "nSP8jo5BMTomNeukSDBXkR"
          : "SZZmKi4P2g8HBjKtnWVNtW",
        api: "https://flagsmith.ream.com.br/api/v1/",
        datadogRum: {
          client: datadogRum,
          trackTraits: true,
        },
      }}
      flagsmith={flagsmith}
    >
      <IoCProvider>
        <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ptBRLocale}>
          <AuthProvider>
            <ThemeProvider theme={Theme}>
              <ThemeProviderV5 theme={Themev5}>
                <UserProvider>
                  <SnackbarProvider
                    autoHideDuration={5000}
                    maxSnack={3}
                    preventDuplicate
                  >
                    <CssBaseline />
                    <HomeUserContextProvider>
                      <ProgrammingTransportProvider>
                        <Routes />
                      </ProgrammingTransportProvider>
                    </HomeUserContextProvider>
                  </SnackbarProvider>
                </UserProvider>
              </ThemeProviderV5>
            </ThemeProvider>
          </AuthProvider>
        </MuiPickersUtilsProvider>
      </IoCProvider>
    </FlagsmithProvider>
  );
};

export default App;
